import {MutableMessageType} from "./MutableMessageType";
import message_typeHtml from './message-type.html?raw';

export let template = message_typeHtml;

interface IParams {
    mutableMessageType: MutableMessageType
}

export class viewModel {
    private readonly t: MutableMessageType;

    constructor(params: IParams) {
        this.t = params.mutableMessageType;
    }
}
